/* TrustedCertificateComponent template */
import { FunctionalComponent, h, Host } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { TrustedCertificateComponent } from './cwc-trusted-certificate';

/**
 * Definition of  parameters that the template needs to work.
 */
interface TrustedCertificateTemplateProps {
  /**
   * The class instance that provides controller functionality for the template
   */
  controller: TrustedCertificateComponent;
  // Specify parameters that are required to be passed down to the template here.
}

const TrustedCertificateTemplate: FunctionalComponent<TrustedCertificateTemplateProps> = ({ controller }) => (
  <Host>
    <script>var _tsConfig = {controller.trustedShopConfig}</script>
    <div id="cwc-trusted-certificate-render" class="cwc-trusted-certificate-render"></div>
  </Host>
);

export default TrustedCertificateTemplate;
